import { render } from "./Rumah.vue?vue&type=template&id=72b0fc1d"
import script from "./Rumah.vue?vue&type=script&lang=js"
export * from "./Rumah.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__